import { useState } from 'react';
import { API } from '../api';

import './Contacto.css';

function Contacto() {
  const [form, setForm] = useState({ 
    nombre: '', 
    email: '', 
    mensaje: '' 
  });

  const [mensaje, setMensaje] = useState('');

  const handleChange = e => {
    setForm({
      ...form, 
      [e.target.name]: e.target.value 
    });
  };

  const handleSubmit = e => {
    e.preventDefault();

    API.post('contacto/', form)
      .then(() => {
        setMensaje('✅ ¡Mensaje enviado correctamente!');
        setForm({ nombre:'', email:'', mensaje:'' });
      })
      .catch(() => {
        setMensaje('❌ Error al enviar el mensaje');
      });
  };

  return (
    <div className="contacto-page">

      {/* FRASE SUPERIOR */}
      <p className="contacto-frase">
        ¡Empieza a planear tu viaje 
        <br />
        hoy!
      </p>

     

      <div className="contacto-grid">

        {/* FORMULARIO */}
        <form className="contacto-form" onSubmit={handleSubmit}>

  <div className="input-icon">
    <span>👤</span>
    <input
      name="nombre"
      placeholder="Nombre completo"
      value={form.nombre}
      onChange={handleChange}
      required
    />
  </div>

  <div className="input-icon">
    <span>📧</span>
    <input
      name="email"
      type="email"
      placeholder="Correo electrónico"
      value={form.email}
      onChange={handleChange}
      required
    />
  </div>

  <div className="input-icon">
    <span>💬</span>
    <textarea
      name="mensaje"
      placeholder="Escribe tu mensaje..."
      rows="4"
      value={form.mensaje}
      onChange={handleChange}
      required
    />
  </div>

  <button type="submit" className="btn-primary">
    Enviar mensaje
  </button>

</form>

        {/* MENSAJE */}
        {mensaje && (
          <div className="contacto-alert">
            {mensaje}
          </div>
        )}

        {/* MAPA */}
        <div className="contacto-mapa">
          <h3>📍 Nuestra ubicación</h3>

          <iframe
            title="Mapa"
            src="https://www.google.com/maps?q=-12.241028,-76.927944&output=embed"
            width="100%"
            height="300"
            style={{ border: 0, borderRadius: "12px" }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>

      </div>
    </div>
  );
}

export default Contacto;
